import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { ConditionalExpr } from '@angular/compiler';

@Injectable()
export class ConvenioAbonoService
{
    constructor(private http: HttpClient) { }
    
    traeConveniosPagados(idUsuario : any, buscador:any){
        return this.http.post(`${environment.urlApiPrestamo}/getListaConveniosSuscritos`,
        {
            idUsuarioAsig: idUsuario,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage
        },
        { headers:this.armaCabecera() }).toPromise();
    }

    traePlanPagoConvenio(idConvenio: any){
        return this.http.get(`${environment.urlApiPrestamo}/getListaPlanPagadoConvenio/${idConvenio}`,
         { headers:this.armaCabecera() }).toPromise();

    }

    traeConvenio(idConvenio:any){
        console.log("idConvenio!!!!",idConvenio)
        return this.http.get(`${environment.urlApiPrestamo}/convenios/${idConvenio}`,
        { headers: this.armaCabecera() }).toPromise();
    }

    traeProveedorSelect(){
       
        return this.http.get(`${environment.urlApiPrestamo}/getProveedores`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traeCategoriaConvenio(){
        return this.http.get(`${environment.urlApiPrestamo}/getTipoConvenio`,
        { headers:this.armaCabecera() }).toPromise();
    }
 
    traePlanAPagarConvenio(idConvenio: any,numCuota: any,idPlan: any){
        console.log(idPlan)
       return this.http.get(`${environment.urlApiPrestamo}/convenioPorId/${idConvenio}/plan/${numCuota}/idplan/${idPlan}`, 
        { headers: this.armaCabecera() }).toPromise();
        
    }

    ExisteOtroConvenio(idConvenio: any,idAfiliado: any,idPlan: any, fechaPago:any, idTipoConvenio:any, idProveedor:any ){ 
       
          return this.http.post(`${environment.urlApiPrestamo}/convenio/validarcuotas`,
            { 
                idConvenio: idConvenio,
                idAfiliado:idAfiliado,
                idPlanPago: idPlan,
                fechaPago:fechaPago,
                idTipoConvenio:idTipoConvenio,
                idProveedor:idProveedor     
             },
         { headers: this.armaCabecera() }).toPromise();
        
    }
    


    traeMontoTotalDisponible(idUsuario : any){
        return this.http.get(`${environment.urlApiPrestamo}/totalDisponible/${idUsuario}`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traeCantidadCuotasProveedor(proveedor: any){
        return this.http.get(`${environment.urlApiPrestamo}/cuotasProveedor/${proveedor}`,
        { headers:this.armaCabecera() }).toPromise(); 
    }
    traeCantidadCuotas(){
       
        return this.http.get(`${environment.urlApiPrestamo}/getCantidadCuotas`,
        { headers:this.armaCabecera() }).toPromise(); 
    }
    traeTipoPrestamo(){

        return this.http.get(`${environment.urlApiPrestamo}/getTipoPrestamo`,
        { headers:this.armaCabecera() }).toPromise(); 
    }
    calcularPlanPago(monto:any, cantidadCuotas:any){
        return this.http.get(`${environment.urlApiPrestamo}/calculaPlanPago/${monto}/cuotas/${cantidadCuotas}`,
        { headers: this.armaCabecera() }).toPromise();
    }

    ingresarPago(usuarioId: any, pagoPrestamo:any){    
        
        return this.http.post(`${environment.urlApiPrestamo}/solicitud/pagoPrestamo`,
           { 
                idPlanPago: pagoPrestamo.idPlanPago,
                montoCuota:pagoPrestamo.montoCuota,
                idPrestamo: pagoPrestamo.idPrestamo,
                numCuota: pagoPrestamo.cantidadCuotas,
                archivoAdjunto:  pagoPrestamo.archivo,
                montoTotalCuota: pagoPrestamo.montoCuota,
                idUsuarioEjecutivo: usuarioId
            
            },
        { headers: this.armaCabecera() }).toPromise();
        
    }
    rechazarPago(usuarioId: any, pagoPrestamo:any,idMotivo: any, motivo:any, comentarioRechazo:any){
      
     
        return this.http.post(`${environment.urlApiPrestamo}/pagos/convenio/rechazar/`,
        {   idPlanPago: pagoPrestamo,
            idMotivoRechazo: idMotivo,
            motivoRechazo: motivo,
            idUsuarioEjecutivo: usuarioId,
            comentarioMotRechazo  : comentarioRechazo
             },
       
     { headers: this.armaCabecera() }).toPromise();
    }
    /*
    aprobarPago(usuarioId: any, pagoPrestamo:any){
        return this.http.post(`${environment.urlApiPrestamo}/pagos/convenio/aprobar/${pagoPrestamo.idPlanPago}`,
     { headers: this.armaCabecera() }).toPromise();
    }
    */
   
    aprobarPago(usuarioId: any, pagoPrestamo:any,fechaAbono:any){
        return this.http.post(`${environment.urlApiPrestamo}/pagos/convenio/aprobar/`,
    { idPlanPago: pagoPrestamo.idPlanPago,
      fechaAbono: fechaAbono,
      idUsuarioEjecutivo: usuarioId
     },
     { headers: this.armaCabecera() }).toPromise();
    }

    traePostulantes(rut: any)
    {
        return this.http.get(`${environment.urlBase}/afiliados/rut/${rut}`, 
               { headers: this.armaCabecera() }).toPromise();
    }
    sinPostulacionesVigentes(idProducto: any, rut: any, titular: any)
    {
        return this.http.get(`${environment.urlBase}/postulaciones/productos/${idProducto}/rut/${rut}/titular/${titular}`,
               { headers: this.armaCabecera() } ).toPromise();
    }

    traeRegiones()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/regiones`,
        { headers:this.armaCabecera() }).toPromise();
    }

    traeEstados()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/estados`,
        { headers:this.armaCabecera() }).toPromise();
    }
    traeEstadosSubsidios()
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/estadosSubsidios`,
        { headers:this.armaCabecera() }).toPromise();
    }


    traeUsuario(rut: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/afiliados/rut/${rut}`,
        { headers:this.armaCabecera() }).toPromise();
    }

    cambiarEstadoPostulacion(idPostulacion: any, estado: any)
    {
        return this.http.post(`${environment.urlApiOperacion}/solicitudes/`,
               { id: idPostulacion, estado: estado }, { headers:this.armaCabecera() } ).toPromise();
    }

    rechazarPostulacion(idPostulacion: any, idMotivoRechazo: any, motivoRechazo: any, comentarioRechazo: any)
    {
    
        return  this.http.post(`${environment.urlApiPrestamo}/solicitudes/`,
        {
            id: idPostulacion,
            estado: 'RECHAZADA',
            idMotivoRechazo: idMotivoRechazo,
            comentarioMotRechazo: comentarioRechazo,
            motivoRechazo: motivoRechazo
        },
        { headers:this.armaCabecera() } ).toPromise()
    }

    traePostulacionesDisponibles(email: any, buscador?: any)

    {
        return this.http.post(`${environment.urlApiSolicitudes}/postulaciones/beca-y-escolaridad/ejecutivo/email`,
        {
            email: email,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            filtroIngresado: false,
            numeroPagina:buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idRegion:buscador?.region,
            rut: buscador?.rut,
            idSolicitud: buscador?.idSolicitud,
            estado: buscador?.estado
        },
        { headers:this.armaCabecera() }).toPromise()
    }

    traePostulacionesAsignadas(idEjecutivo: any, buscador?: any)
    {
        return this.http.post(`${environment.urlApiSolicitudes}/postulaciones/beca-y-escolaridad/ejecutivos/id`,
        {
            id:idEjecutivo,
            numeroPagina: buscador?.currentPage,
            tamanioPagina: buscador?.itemsPerPage,
            idSolicitud: buscador?.idSolicitud,
            fechaInicial: buscador?.fechaInicio?.split('-')?.reverse()?.join('-'),
            fechaFinal: buscador?.fechaFin?.split('-')?.reverse()?.join('-'),
            rut: buscador?.rut,
            estado: buscador?.estado
        },
        { headers:this.armaCabecera() }).toPromise()
    }

    asignaPostulacion(postulaciones: any, idEjecutivo: any)
    {
    
        return this.http.post(`${environment.urlApiOperacion}/solicitudes/asignar/ejecutivo/${idEjecutivo}`,
        postulaciones, { headers:this.armaCabecera() } ).toPromise()
    }

    traePostulacionBeca(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/becas/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    traePostulacionEscolaridad(idPostulacion: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/postulaciones/${idPostulacion}/escolaridad/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    editaPostulacionBeca(idPostulacion: any, idCarga: any, nota: any, idCurso: any,idUsuario:any)
    {
        return this.http.put(`${environment.urlApiOperacion}/solicitudes/`,
        {
            id: idPostulacion,
            idCarga: idCarga,
            idUsuario: idUsuario,
            idProducto: 1,
            beca: { calificacion:nota, idCurso:idCurso }
        },
        { headers:this.armaCabecera() } ).toPromise()
    }

    

    motivoRechazo(idProducto: any)
    {
        return this.http.get(`${environment.urlApiSolicitudes}/motivoRechazo/productos/${idProducto}/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    traeArchivos(idPlanPago: any)
    {
        return this.http.get(`${environment.urlApiPrestamo}/planPago/${idPlanPago}/archivo-adjunto/`,
               { headers:this.armaCabecera() }).toPromise()
    }

    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });
    }
}
